import { render, staticRenderFns } from "./stepped-kpis-bar.component.vue?vue&type=template&id=503bd1f6&scoped=true"
import script from "./stepped-kpis-bar.component.vue?vue&type=script&lang=ts"
export * from "./stepped-kpis-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./stepped-kpis-bar.component.vue?vue&type=style&index=0&id=503bd1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bd1f6",
  null
  
)

export default component.exports